var _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBetting(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#3988FD"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3625_25036)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0056 6.46437C11.9696 6.46766 13.5358 8.03387 13.5307 9.98989C13.5255 11.96 11.9522 13.5149 9.97274 13.5055C8.02612 13.4966 6.4693 11.9295 6.4707 9.98049C6.47211 8.02401 8.04303 6.46108 10.0056 6.46437Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.62098 5.76507C8.73526 5.86087 7.95285 6.18116 7.29068 6.72734C6.87036 6.30843 6.45896 5.89844 6.03723 5.47906C7.04647 4.59992 8.23792 4.10539 9.62098 4.00114V5.76507Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.76676 9.61652H4.0033C4.09628 8.23769 4.59926 7.04952 5.47934 6.03183C5.90154 6.45027 6.31341 6.85932 6.73702 7.2787C6.18473 7.93994 5.86444 8.72845 5.76676 9.61652Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.74217 12.6983C6.32467 13.1148 5.91703 13.5211 5.49108 13.9461C4.59925 12.9336 4.10567 11.7416 4 10.3609H5.76769C5.86396 11.2405 6.18472 12.0286 6.74217 12.6983Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3569 4.00022C11.7588 4.10119 12.9497 4.59806 13.9646 5.47721C13.5448 5.89659 13.1343 6.30658 12.714 6.72643C12.1819 6.29531 11.5606 5.98441 10.8599 5.8393C10.695 5.80501 10.4654 5.81581 10.386 5.71343C10.3015 5.60448 10.3583 5.38516 10.3579 5.21375C10.3564 4.81832 10.3574 4.42242 10.3574 4.00022H10.3569Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 9.61042H14.237C14.1384 8.73878 13.8209 7.94088 13.2522 7.2632C13.672 6.8457 14.0806 6.439 14.5061 6.01633C15.4012 7.03825 15.899 8.22923 16 9.61089V9.61042Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4981 13.9634C14.074 13.5379 13.6725 13.135 13.2517 12.7123C13.8026 12.037 14.1407 11.2574 14.2304 10.3595H15.9986C15.9032 11.7327 15.404 12.9227 14.4981 13.9634Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.62759 15.9687C8.2356 15.864 7.04509 15.3681 6.02271 14.4786C6.44255 14.0616 6.85066 13.6553 7.27568 13.2331C7.9449 13.7807 8.73059 14.1109 9.62759 14.2043V15.9683V15.9687Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9825 14.4772C12.9446 15.3733 11.755 15.8706 10.3752 15.9674V14.2086C11.2516 14.1128 12.0499 13.7925 12.7318 13.2261C13.1508 13.645 13.5584 14.0527 13.9825 14.4772Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3625_25036"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 11.9685,
    fill: "white",
    transform: "translate(4 4.00011)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBetting);
export default __webpack_public_path__ + "static/media/betting.7e6e5d14efe83ee9822f04289dc6db61.svg";
export { ForwardRef as ReactComponent };